import React from "react";
import Accordion from "react-bootstrap/Accordion";
import BaseAccordionItem from "./BaseAccordionItem";

const BaseAccordionList = ({
  accordionClasses,
  accordionFunctions,
  expandedItem,
  onExpandItem,
}) => {
  return (
    <Accordion defaultActiveKey="0" className={accordionClasses}>
      {accordionFunctions.map((item, index) => {
        const headerText = item.name;
        const content = Object.values(item)[1];

        return (
          <BaseAccordionItem
            key={headerText}
            eventKey={index + 1}
            expandedContent={content}
            expandedItem={expandedItem}
            headerText={headerText}
            onExpandItem={onExpandItem}
            isValid={Object.values(item)[0][0]?.isValid}
          />
        );
      })}
    </Accordion>
  );
};

export default BaseAccordionList;